import intl from 'react-intl-universal';
import { message } from 'antd';
import { TIANRUNIdentifier } from '@/config';

type CallBackEventTypes =
    | 'login'
    | 'logout'
    | 'sipLink'
    | 'sipUnlink'
    | 'PREVIEW_OUTCALL'
    | 'PREVIEW_OUTCALL_CANCEL';

type ListenerEventTypes =
    | 'status' // 状态变化
    | 'kickout' // 被动下线（单点）
    | 'breakLine' // 断线（可能是网络原因）
    | 'logout' // 初始化 主动接收掉线事件
    | 'ringing' // 响铃
    | 'changeStatus' // 状态变化
    // | 'sip_connected'
    | 'wrapup' // 挂断
    | 'call' // 外呼
    | 'busy' // 通话中
    | 'joinQueue' // 加入队列排队
    | 'leaveQueue' // 离开队列排队
    | 'previewOutcallRinging' // 预览外呼外呼结果
    | 'previewOutcallBridge' // 外呼接听
    | 'previewOutcallStart'
    | 'previewOutcall'; // 外呼呼叫结果

const CallbackMap: {
    [key in CallBackEventTypes]?: string;
} = {
    // 登陆
    login: window.ClinkAgent.ResponseType.LOGIN,
    // 退出登陆
    logout: window.ClinkAgent.ResponseType.LOGOUT,
    PREVIEW_OUTCALL: window.ClinkAgent.ResponseType.PREVIEW_OUTCALL,
    PREVIEW_OUTCALL_CANCEL:
        window.ClinkAgent.ResponseType.PREVIEW_OUTCALL_CANCEL,
};

const ListenerMap: {
    [key in ListenerEventTypes]?: string;
} = {
    // 坐席状态
    status: window.ClinkAgent.EventType.STATUS,
    previewOutcallRinging: window.ClinkAgent.EventType.PREVIEW_OUTCALL_RINGING,
    previewOutcallBridge: window.ClinkAgent.EventType.PREVIEW_OUTCALL_BRIDGE,
    previewOutcall: window.ClinkAgent.EventType.PREVIEW_OUTCALL,
    previewOutcallStart: window.ClinkAgent.EventType.PREVIEW_OUTCALL_START,
    joinQueue: window.ClinkAgent.EventType.JOIN_QUEUE,
    leaveQueue: window.ClinkAgent.EventType.LEAVE_QUEUE,
    ringing: window.ClinkAgent.EventType.RINGING,
    kickout: window.ClinkAgent.EventType.KICKOUT,
    breakLine: window.ClinkAgent.EventType.BREAK_LINE,
};

type resultType = {
    code: number | string;
    action: string;
    callType: number; // 1: 呼入 4 外呼
    // status: string;
    customerNumber: string; // 呼入手机号
    msg?: string;
    reqType?: string;
    mainUniqueId: string; // 通话ID
};

let isInit = false;

// 是否是外呼
let driving: boolean = false;
// 是否已登陆
let isLogin: boolean = false;

export default function SoftPhoneUtils(
    listeners: {
        [key in ListenerEventTypes]?: (res: resultType) => void;
    } = {},
) {
    let callbacks: {
        [key in CallBackEventTypes | ListenerEventTypes]?: {
            resolve: Promise<resultType>;
            reject: Promise<resultType>;
        };
    } = {};

    let bindType: number = 0;

    let extraData: {
        [key: string]: string | number | undefined;
    } = {};

    if (!isInit) {
        window.ClinkAgent?.setup(
            {
                sipPhone: true,
                debug: true,
            },
            () => {
                isInit = true;
                window.ClinkAgent.registerListener(ListenerMap.status, (res) =>
                    statusChange(res),
                );
            },
        );
    }

    function previewOutcall(data) {
        console.log('外呼结果', data.code, data);
        // this.listeners?.ringing?.(data);
    }
    function previewOutcallRinging(data) {
        console.log('外呼响铃', data.code, data);
        // listeners?.ringing?.({
        //     ...data,
        //     driving: true,
        // });
    }
    function previewOutcallBridge(data) {
        console.log('外呼接听', listeners?.busy, data);
        listeners?.busy?.(data);
    }

    function statusChange(data: resultType) {
        console.log('坐席状态变化', data.code, data, driving);
        const status = data.code;
        switch (status) {
            case 'RINGING':
                // 外呼不适用该事件, 接收专门的响铃事件，需要拿更多信息，暂时废弃
                // if (!this.driving) {
                //     this.listeners?.ringing?.(data);
                // }
                break;
            case 'IDLE':
                driving = false;
                listeners?.changeStatus?.(data);
                break;
            case 'PAUSE':
                driving = false;
                listeners?.changeStatus?.(data);
                break;
            case 'CALLING':
                driving = data.callType === 4;
                if (callbacks.call) {
                    callbacks.call.resolve?.(data);
                    delete callbacks.call;
                } else {
                    listeners?.call?.(data);
                }
                break;
            case 'BUSY':
                // 外呼不适用该事件
                console.log('-=-=-=-=BUSY====', data, callbacks.sipLink);
                if (
                    !driving &&
                    data.action !== 'hold' &&
                    data.action !== 'unhold'
                ) {
                    if (callbacks.sipLink) {
                        callbacks.sipLink?.resolve(data);
                        delete callbacks.sipLink;
                    } else {
                        listeners?.busy?.(data);
                    }
                }

                break;
            case 'WRAPUP':
                driving = false;
                // 挂断的回调，如果有没有尝试看有没有监听挂断事件
                if (callbacks.sipUnlink) {
                    callbacks.sipUnlink?.resolve(data);
                    delete callbacks.sipUnlink;
                } else {
                    listeners?.wrapup?.(data);
                }
                break;
        }
    }

    function login(params: {
        // identifier: 'paopaomate1' | 'popmart';
        cno: string;
        password: string;
        bindTel: string;
        bindType: number;
        loginStatus: number;
    }) {
        bindType = params.bindType;

        return new Promise((resolve, reject) => {
            window.ClinkAgent.registerCallback(CallbackMap.login, (res) => {
                if (res.code === 0) {
                    // 订阅监控事件
                    window.ClinkAgent.unsubscribeMonitor();
                    window.ClinkAgent.subscribeMonitor();
                    window.ClinkAgent.registerListener(
                        ListenerMap.ringing,
                        (res: resultType) => {
                            console.log('监听响铃状态=====', res);
                            driving = res.callType === 4;
                            // if (!driving) {
                            listeners?.ringing?.({
                                ...res,
                                driving,
                            });
                            // }
                        },
                    );

                    // 单点登录掉线
                    window.ClinkAgent.registerListener(
                        ListenerMap.kickout,
                        (res) => {
                            listeners?.logout?.({
                                ...res,
                                message: intl.get(
                                    '该账号已在其他地方登录，如有进行中的热线通话，点击确认后将结束本次通话',
                                ),
                            });
                        },
                    );
                    // 心跳断连（可能是网路原因）
                    window.ClinkAgent.registerListener(
                        ListenerMap.breakLine,
                        (res) => {
                            listeners?.logout?.({
                                ...res,
                                message: intl.get(
                                    '软电话已掉线，如有进行中的热线通话，点击确认后将结束本次通话',
                                ),
                            });
                        },
                    );

                    isLogin = true;
                    resolve(res);
                } else {
                    reject(res);
                }
            });
            if (!callbacks) {
                callbacks = {};
            }
            window.ClinkAgent.login({
                identifier: TIANRUNIdentifier,
                ...params,
            });
        });
    }

    function logout(
        params = {
            logoutMode: 1,
            removeBinding: 1,
        },
    ) {
        return new Promise((resolve, reject) => {
            window.ClinkAgent.registerCallback(CallbackMap.logout, (res) => {
                if (res.code === 0) {
                    isLogin = false;
                    resolve(res);
                } else {
                    reject(res);
                }
            });
            if (!callbacks) {
                callbacks = {};
            }
            window.ClinkAgent.logout(params);
        });
    }

    // 外呼
    function sipLink() {
        if (bindType !== 3) {
            message.warning(intl.get('请确保登陆注册类型为软电话'));
            return;
        }

        return new Promise((resolve, reject) => {
            if (!callbacks) {
                callbacks = {};
            }
            callbacks.sipLink = {
                resolve,
                reject,
            };
            window.ClinkAgent.sipLink();
        });
    }

    function hangup(isRinging: boolean) {
        return new Promise((resolve, reject) => {
            if (!callbacks) {
                callbacks = {};
            }
            callbacks.sipUnlink = {
                resolve,
                reject,
            };
            // 呼入响铃阶段用拒接
            if (isRinging && !driving) {
                window.ClinkAgent.refuse();
            } else {
                // 通话中用挂断
                window.ClinkAgent.unlink();
            }
        });
    }

    function call(params: {
        tel: string;
        extraParams?: { [key: string]: string | number | undefined };
    }) {
        if (!isLogin) {
            message.success(intl.get('请先登陆软电话'));
            return;
        }
        extraData = params.extraParams || {};
        return new Promise((resolve, reject) => {
            driving = true;
            if (!callbacks) {
                callbacks = {};
            }

            window.ClinkAgent.registerCallback(
                CallbackMap.PREVIEW_OUTCALL,
                (res) => {
                    if (res.code !== 0) {
                        message.error(res.msg);
                    }
                },
            );

            window.ClinkAgent.registerListener(
                ListenerMap.previewOutcall,
                (res) => previewOutcall(res),
            );
            window.ClinkAgent.registerListener(
                ListenerMap.previewOutcallRinging,
                (res) => previewOutcallRinging(res),
            );
            window.ClinkAgent.registerListener(
                ListenerMap.previewOutcallBridge,
                (res) => previewOutcallBridge(res),
            );

            callbacks.call = {
                resolve,
                reject,
            };
            window.ClinkAgent.previewOutcall(params);
        });
    }

    /**
     * 置忙
     */
    function pause(params: { pauseType: 1 | 2; pauseDescription: string }) {
        window.ClinkAgent.pause(params);
    }

    /**
     * 置闲
     */

    function unpause() {
        window.ClinkAgent.unpause();
    }

    /**
     * 保持
     */
    function hold(holdType = 0) {
        window.ClinkAgent.hold({
            holdType,
        });
    }
    /**
     * 保持取消
     */
    function unhold(holdType = 0) {
        window.ClinkAgent.unhold({
            holdType,
        });
    }

    /**
     * 静音
     */
    function mute(direction = 'in') {
        window.ClinkAgent.mute({
            direction,
        });
    }
    /**
     * 取消静音
     */
    function unmute(direction = 'in') {
        window.ClinkAgent.unmute({
            direction,
        });
    }

    /**
     * 发送按键
     */

    function keyDown(key: string | number) {
        window.ClinkAgent.dtmf({
            direction: 'out',
            digits: key,
        });
    }

    /**
     * 订阅排队人数变化
     */
    function registerQueueChange(fn: (type: 'add' | 'reduce') => void) {
        console.log('订阅队列数量变化');
        window.ClinkAgent.registerListener(ListenerMap.joinQueue, (res) => {
            console.log('加入队列', res);
            fn?.('add');
        });
        window.ClinkAgent.registerListener(ListenerMap.leaveQueue, (res) => {
            console.log('离开队列', res);
            fn?.('reduce');
        });
    }

    /**
     * 转队列
     */
    function transfer(params: {
        objectType: number;
        transferObject: string;
        hold: number;
    }) {
        window.ClinkAgent.transfer(params);
    }

    function getExtraData() {
        return extraData || {};
    }

    return {
        keyDown,
        driving,
        isLogin,
        login,
        logout,
        sipLink,
        hangup,
        call,
        pause,
        unpause,
        hold,
        unhold,
        mute,
        unmute,
        registerQueueChange,
        transfer,
        getExtraData,
    };
}
